
define( 'FORCES_AND_MOTION_BASICS/../nls/eu/forces-and-motion-basics-strings',{
          "none": "Ezer",
          "force": "Indarra",
          "values": "Balioak",
          "frictionTitle": "Igurtzimendua",
          "redWins": "Gorria irabazle!",
          "frictionForce": "Igurtzimendu indarra",
          "pause": "Geldi",
          "friction": "Igurtzimendua",
          "forces-and-motion-basics.name": "Indarrak eta higidura: Oinarrizkoa",
          "appliedForce": "Ezarritako indarra",
          "leftForce": "Ezkerreko indarra",
          "massDisplay.pattern": "{0} kg",
          "rightForce": "Eskubiko indarra",
          "sound": "Soinua",
          "lots": "Multzoak",
          "forces": "Indarrak",
          "motion": "Higidura",
          "tugOfWar": "Sokatira",
          "go": "Aurrera!",
          "newtons.n": "Newtonak (N)",
          "sumOfForcesEqualsZero": "Indar erresultantea = 0",
          "blueWins": "Urdina irabazle!",
          "speed": "Abiadura",
          "sumOfForces": "Indar erresultantea",
          "return": "Itzuli",
          "newtons": "Newtonak",
          "masses": "Masa",
          "forceReadout.pattern": "{0}N"
        } );